import { render, staticRenderFns } from "./MessageInboxPopover.vue?vue&type=template&id=0abc1d24&scoped=true&"
import script from "./MessageInboxPopover.vue?vue&type=script&lang=ts&"
export * from "./MessageInboxPopover.vue?vue&type=script&lang=ts&"
import style0 from "./MessageInboxPopover.vue?vue&type=style&index=0&id=0abc1d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abc1d24",
  null
  
)

export default component.exports